var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtLayoutHeaderFooter',_vm._b({attrs:{"bg":['none', '#F6F6F9']}},'OmtLayoutHeaderFooter',{
    header: {
      titleLabel: 'Cadastro de administradores'
    },
    footer: false
  },false),[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }